import "./listQuery.css";
import "../dashboard/Dashboard.css"
import QueryListCard from "../../components/QueryList/queryList";
import HeaderClientAdmin from "../../components/HeaderClientAdmin/HeaderClientAdmin";

const ListQuery = () => {

    return (
        <>
            <HeaderClientAdmin />
            <div className="page-container">

                <div className="dashboard-content">
                    <div className="row g-2 dashboard-container">
                        <div className="col-md-12">
                            <div className="dashboard-main-card">
                                <div className="dashboard-content-wrapper">
                                    <div
                                        className={`row justify-content-center w-100`}
                                    >
                                        <div className="col-md-7">
                                            <QueryListCard />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListQuery;
